<h1 class="title">Ignorerade</h1>
<p class="brodtext-medium-14">
  Ibland skickas det fynd eller analyser till Svebar som inte ska importeras och sparas så som virus och parasiter eller <br>
  direktmikroskopi. Dessa poster som skickas till Svebar kommer att ignoreras och inte sparas i Svebar.
</p>
<app-button-set [buttons]="ignoreTypesButtonSet" (select)="onSelect($event)"></app-button-set>
<app-table [config]="tableConfig"></app-table>
